import type { MouseEvent } from 'react';
import type { NavigateFunction } from 'react-router-dom';

export const spaLinkProps = (to: string, navigate: NavigateFunction) => ({
  href: to,
  onClick: (event: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (
      event.defaultPrevented
      || event.button !== 0
      || event.metaKey
      || event.altKey
      || event.ctrlKey
      || event.shiftKey
    ) {
      return;
    }
    event.preventDefault();
    navigate(to);
  },
});
